class EnhancedEventStreamer {

  static init (enhancedEvents, options) {
    EnhancedEventStreamer.enhancedEvents = enhancedEvents
    EnhancedEventStreamer.enhancedEvents.onAdd = EnhancedEventStreamer.handleAddEvent
    EnhancedEventStreamer.syncNext = 0
    EnhancedEventStreamer.session = options.session
    EnhancedEventStreamer.journey = options.journey
    EnhancedEventStreamer.release = options.release
    EnhancedEventStreamer.environment = options.environment
    EnhancedEventStreamer.resourceUrl = options.resourceUrl
    EnhancedEventStreamer.orgId = options.orgId,
    EnhancedEventStreamer.orgType = options.orgType
  }

  static handleAddEvent (event) {
    if (event.type === 'CLOSE') {
      EnhancedEventStreamer.sendBeacon(event)
      EnhancedEventStreamer.syncNext++
    } else if (event.type === 'CLOSE_BEFORE') {
      // Send event immediately, needs to be synchronous
      EnhancedEventStreamer.send(event)
      EnhancedEventStreamer.syncNext++
    }
  }

  static run () {
    const list = EnhancedEventStreamer.enhancedEvents.list
    const length = list.length
    const syncNext = EnhancedEventStreamer.syncNext

    for (let i = syncNext; i < length; i++) {
      EnhancedEventStreamer.send(list[i])
    }

    EnhancedEventStreamer.syncNext = length
  }

  static schedule () {
    EnhancedEventStreamer.schedule = setInterval(() => {
      EnhancedEventStreamer.run()
    }, 500)
  }

  static getRequestData (event) {
    return {
      Data: {
        event: event,
        session: EnhancedEventStreamer.session,
        journey: EnhancedEventStreamer.journey,
        release: EnhancedEventStreamer.release,
        environment: EnhancedEventStreamer.environment,
        resourceUrl: EnhancedEventStreamer.resourceUrl,
        orgId: EnhancedEventStreamer.orgId,
        orgType: EnhancedEventStreamer.orgType
      },
      KinesisPartitionKey: EnhancedEventStreamer.session
    }
  }

  static getCaptureUri () {
    return process.env.REACT_APP_ENGAGEMENT_SERVICE_URI + '/' + process.env.REACT_APP_ENGAGEMENT_CAPTURE
  }
  
  static send (event) {
    const message = this.getRequestData(event)

    const req = new Request(this.getCaptureUri(), {
      method: 'POST',
      headers: { 'content-type': 'text/plain' },
      body: JSON.stringify(message)
    })

    if (event.type === 'CLOSE_BEFORE') {
      req.synchronous = true
    }
    
    fetch(req).then(res => { })
  }

  static sendBeacon (event) {
    window.navigator.sendBeacon(this.getCaptureUri(), JSON.stringify(this.getRequestData(event)))
  }
}

export default EnhancedEventStreamer
